var map = {
	"./green-dots.svg": 322,
	"./green-horizontal-bars.svg": 323,
	"./green-points.svg": 324,
	"./green-solid.svg": 166,
	"./green-squares.svg": 325,
	"./purple-dots.svg": 326,
	"./purple-horizontal-bars.svg": 327,
	"./purple-points.svg": 328,
	"./purple-solid.svg": 165,
	"./purple-squares.svg": 329,
	"./purple-vertical-bars.svg": 167
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 701;